const { when } = require('simply-deferred');
const {ITEM_VIEW_TASK, ITEM_VIEW_DOCUMENT} = require("core/gd/app-manager/item-view");

const debug = {
    dev: false,
    head: 'GD.SHARED-VIEW.APP-LAUNCHER'
};

class SharedViewAppManager {

    loadAndRun(LoaderClass,params={}) {
        const resourceLoader = new LoaderClass();

        const loader = resourceLoader.load(params, true);
        loader.done((App, apiResponse)=>{
            this.launchApp(App,_.assign({}, params, {apiResponse}));
        });

        loader.fail(()=>{
            console.error("Something is wrong. Can't load application or related resources.");
        });

        return loader;
    }

    launchApp(AppClass,params={}) {
        if (debug.dev) console.log(debug.head,".lauchApp","AppClass=",AppClass,"params=",params);

        this.destroyModal();
        this.destroyFullModal();

        params.initDone = true;
        params.noAccess = false;

        if (gd.app && gd.app.routerPath === gd.router.history.getPath()) {
            if (debug.dev) console.log(debug.head," Same App - no Init",params);
            //this.app.init(params);
        } else {
            // kill previous app
            this.destroyApp();

            if (debug.dev) console.log(debug.head," new App - Init",params);

            gd.app = new AppClass();
            gd.app.init(params);

            // force push url used when we open task first and need my work to be back link
            if (params && params.forcePushUrl)  gd.app.routerPath = params.forcePushUrl;
            else                                gd.app.routerPath = gd.router.history.getPath();
        }

        if (params.noAccess) {
            gd.app.renderNoAccess();
            return;
        }

        // something happened during init... no futher action should happen
        if (params.error) {
            return
        }

        when(params.initDone).then(
            ()=>{
                if (debug.dev) console.log(debug.head," app.Start",params);
                gd.app.start();
            },
            (data)=>{ if (debug.dev) console.log("launch App: init rejected", data); }
        );
    }

    loadAndRunItemView(LoaderClass,params={}) {
        const resourceLoader = new LoaderClass(params);

        const showLoading = false;
        when(resourceLoader.load(showLoading)).then(
            (App)=>{gd.appManager.launchItemView(App,params)},
            ()=>{console.error("Something is wrong in item view app loading...")}
        )
    }

    launchItemView(AppClass, params) {
        this.destroyModal();
        this.destroyFullModal();

        params.initDone = true;

        return gd.itemView.open(params.containerId, AppClass, params);
    }

    // Full modal apps should be deleted in the future and use fullScreenApp instead because it should live within div-zro to provide support for modal windows
    launchFullModal(AppClass,params,className=null) {
        this.destroyModal();
        this.destroyFullModal();

        // create modal window
        gd.layout.fullModal.create(className);

        // run app
        gd.fullModalApp = new AppClass();
        gd.fullModalApp.init(params);
        gd.fullModalApp.start();
    }

    destroyModal() {
        if (gd.modal) gd.modal.hide();
    }

    destroyApp() {
        if (debug.dev) { console.log(debug.head,".destroyApp()",gd.app); }
        if (gd.app) {

            if (gd.app.__destroy) gd.app.__destroy();
            if (gd.app.destructor) gd.app.destructor();

            if (gd.layout.isFullScreenEnabled()) gd.layout.fullScreen(false);
        }

        gd.growl.removeAllButSticky();
    }

    destroyFullModal() {
        if (gd.fullModalApp) {
            gd.fullModalApp.__destroy();
            gd.fullModalApp = null;
        }
        gd.layout.fullModal.destroy();
    }
}

module.exports = SharedViewAppManager;